var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Prop, Vue, Model } from 'vue-property-decorator';
let MiButton = class MiButton extends Vue {
    mounted() {
        //
    }
};
__decorate([
    Model('isBusy', { default: false }),
    __metadata("design:type", Boolean)
], MiButton.prototype, "isBusy", void 0);
__decorate([
    Prop({ default: '' }),
    __metadata("design:type", String)
], MiButton.prototype, "icon", void 0);
__decorate([
    Prop({ default: 'primary' }),
    __metadata("design:type", String)
], MiButton.prototype, "color", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], MiButton.prototype, "disabled", void 0);
__decorate([
    Prop({ default: '' }),
    __metadata("design:type", String)
], MiButton.prototype, "to", void 0);
MiButton = __decorate([
    Component({})
], MiButton);
export default MiButton;
